var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconViewon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.996,
    height: 18.681,
    viewBox: "0 0 21.996 18.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Icon",
    "data-name": "View Icon",
    transform: "translate(-1220 -1989.544)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(1220 1991.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M11.723,15.386a3.693,3.693,0,1,1,3.723-3.693A3.719,3.719,0,0,1,11.723,15.386Zm0-5.539a1.846,1.846,0,1,0,1.862,1.846A1.86,1.86,0,0,0,11.723,9.846Z",
    transform: "translate(-0.726 -4.391)",
    fill: "#304669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M10.948,18.6C4.1,18.6.269,12.032.087,11.758a.829.829,0,0,1,0-.913C.269,10.571,4.1,4,10.948,4s10.678,6.571,10.861,6.845a.829.829,0,0,1,0,.913C21.626,12.032,17.793,18.6,10.948,18.6ZM2,11.3c.913,1.369,4.107,5.476,8.944,5.476s8.032-4.107,8.944-5.476c-.913-1.369-4.107-5.476-8.944-5.476S2.916,9.932,2,11.3Z",
    transform: "translate(0.05 -4)",
    fill: "#304669"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 2.207,
    height: 22.003,
    transform: "translate(1237.226 1989.544) rotate(45)",
    fill: "#304669"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_50",
    "data-name": "Rectangle 50",
    width: 2.207,
    height: 22.003,
    transform: "translate(1238.788 1991.106) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconViewon);
export default __webpack_public_path__ + "static/media/icon_viewon.1535eb1592f825690efb22c3d10ab63f.svg";
export { ForwardRef as ReactComponent };